import { useActiveLocationsStore } from "@/stores/useActiveLocationsStore";
import { LocationBadges } from "./LocationBadges";

interface ActiveLocationBadgesProps {
  className?: string;
}

export function ActiveLocationBadges({ className }: ActiveLocationBadgesProps) {
  const { isAllSelected, availableLocations, activeLocationIds } = useActiveLocationsStore();

  const selectedLocations = isAllSelected 
    ? availableLocations 
    : availableLocations.filter(loc => activeLocationIds.includes(loc.locationId));

  return (
    <LocationBadges 
      locations={selectedLocations}
      isLoading={availableLocations.length === 0}
      className={className}
    />
  );
}

